<div class="form">

    <form [formGroup]="signUpForm" (ngSubmit)="signUp()">
        <div class="title">Sign up</div>

        <app-alert />
        <div class="label">Name</div>
        <input type="text" required autofocus formControlName="name" class="field" maxlength="50">
        <div class="label">Email</div>
        <input type="email" required autofocus formControlName="email" class="field" maxlength="50">
        <div class="label">Password</div>
        <div class="password-input">
            <input [type]="passwordState.type" required formControlName="password" class="field" maxlength="50">
            <span class="password-toggle" (click)="passwordState.toggle()" [class.password-visible]="passwordState.visible"></span>
        </div>
        <button type="submit" [disabled]="!signUpForm.valid || isLoading" class="button">
            <span [hidden]="isLoading">Sign up</span>
            <img src="../../../assets/img/spinner.svg" alt="Loading" [hidden]="!isLoading"/>
        </button>
        <div class="text-center" style="margin: 24px 0px;">
            <span routerLink="/login" class="link important">Already have an account?</span>
        </div>
        <div class="text-center text">
            You can also create an account <br/>within the <a href="https://www.15club.golf/" class="link">15th
            Club</a> app.
        </div>
    </form>
</div>
